import { render } from "./R2RChat.vue?vue&type=template&id=eeaa4600&scoped=true"
import script from "./R2RChat.vue?vue&type=script&lang=js"
export * from "./R2RChat.vue?vue&type=script&lang=js"

import "./R2RChat.vue?vue&type=style&index=0&id=eeaa4600&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeaa4600"]])

export default __exports__